import CustomFooter from './Footer';

export default CustomFooter;
